import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { get } from 'lodash'
import { Title, Overview, CircleBadge } from 'components/misc'
import { getActivityClassName, getActivityIconName } from 'helpers/dashboard'
import { ACTIVITY_SECTIONS } from 'constants/enums'

const actOverviewMock = { loading: false }

const ajColorClass = getActivityClassName(
  ACTIVITY_SECTIONS.adventurous_journey.id
)
const titleStyle = { float: 'left', marginRight: 10 }

class AJOverview extends Component {
  static propTypes = {
    aj: PropTypes.object.isRequired,
    downloadButton: PropTypes.any
  }

  render() {
    const { aj, downloadButton } = this.props

    return (
      <div>
        <Title colorClass={ajColorClass} h3 bold>
          <CircleBadge colorClass={ajColorClass} style={titleStyle} small>
            {getActivityIconName(ACTIVITY_SECTIONS.adventurous_journey.id)}
          </CircleBadge>
          <FormattedMessage
            id="moduleTitle.adventurous_journey"
            defaultMessage="Adventurous Journey"
          />
        </Title>

        <Title
          h5
          colorClass={ajColorClass}
          style={{ margin: 0, fontWeight: 'bold' }}
          intlKey="moduleTitle.preparation_and_training"
        >
          Preparation and training
        </Title>

        <Overview
          activityOverview={actOverviewMock}
          activitySection={ACTIVITY_SECTIONS.adventurous_journey.id}
          content={[
            {
              id: '90',
              content: get(
                aj,
                'ajPreparationAndTrainingStateType.translationText'
              ),
              intlKey: 'label.status',
              label: 'Status',
              ico: 'info'
            }
          ]}
        />

        {get(aj, 'adventurousJourneys', []).map(event => {
          return (
            <div key={event.id}>
              <Title
                h5
                colorClass={ajColorClass}
                style={{ margin: 0, fontWeight: 'bold' }}
              >
                <FormattedMessage
                  id="moduleTitle.event_journey"
                  defaultMessage="{event} Journey"
                  values={{
                    event: get(event, 'ajEvent.ajEventCategory.translationText')
                  }}
                />
              </Title>

              <div className="row">
                <div className="col-xs-12 col-md-6">
                  <Overview
                    activityOverview={actOverviewMock}
                    activitySection={ACTIVITY_SECTIONS.adventurous_journey.id}
                    content={[
                      {
                        id: '90',
                        content: get(event, 'state.translationText'),
                        intlKey: 'label.status',
                        label: 'Status',
                        ico: 'info'
                      },
                      {
                        id: '92',
                        content: get(event, 'ajEvent.startDate'),
                        intlKey: 'label.start_date',
                        label: 'Start Date',
                        ico: 'date',
                        date: true
                      },
                      {
                        id: '93',
                        content: get(
                          event,
                          'ajEvent.activityCategory.translatedName'
                        ),
                        intlKey: 'label.journey_activity',
                        label: 'Journey Activity',
                        ico: 'filter-hdr'
                      },
                      {
                        id: '94',
                        content: get(event, 'ajEvent.note'),
                        intlKey: 'label.note',
                        label: 'Note',
                        ico: 'subject'
                      }
                    ]}
                  />
                </div>
                <div className="col-xs-12 col-md-6">
                  <Overview
                    activityOverview={actOverviewMock}
                    activitySection={ACTIVITY_SECTIONS.adventurous_journey.id}
                    content={[
                      {
                        id: '90',
                        content: get(event, 'ajEvent.aim'),
                        intlKey: 'label.goal',
                        label: 'Goal',
                        ico: 'info'
                      },
                      {
                        id: '92',
                        content: get(event, 'ajEvent.endDate'),
                        intlKey: 'label.end_date',
                        label: 'End Date',
                        ico: 'date',
                        date: true
                      },
                      {
                        id: '93',
                        content: get(
                          event,
                          'ajEvent.modeOfTransportType.translationText'
                        ),
                        intlKey: 'label.mode_of_transport',
                        label: 'Mode of Transport',
                        ico: 'bike'
                      },
                      {
                        id: '94',
                        content: get(event, 'ajEvent.country.name'),
                        intlKey: 'label.location',
                        label: 'Location',
                        ico: 'map'
                      }
                    ]}
                  />
                </div>
              </div>
            </div>
          )
        })}

        {downloadButton}
      </div>
    )
  }
}

export default AJOverview
